import Card from 'components/Card';
import Icon from 'components/Icon';
import Reload from 'components/Reload';
import Text from 'components/Text';
import styled from 'styled-components/native';

export const InvoicePostingContainer = styled(Card)`
  padding: 0px;
`;

export const ListItem = styled.View`
  padding-right: 24px;
  padding-left: 24px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom-color: #f2f2f2;
  border-bottom-width: 1px;
  border-style: solid;
  border-width: 0;
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const HeaderTitle = styled.View`
  flex: 1;
`;

export const HeaderTitleWidth = styled.View`
  width: ${props => `${props.width}px`};
`;

export const CustomReload = styled(Reload)`
  align-items: center;
`;

export const HeaderTitleText = styled(Text)`
  color: ${props => props.theme.colors.base.slot1};
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;
  overflow: hidden;
  margin-right: 8px;
`;

export const HeaderSubtitle = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[700]};
  font-size: 14px;
  color: ${props =>
    props.isChargeBack
      ? props.theme.colors.support.slot3
      : props.theme.colors.grayscale.slot6};
`;

export const Footer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 16px;
`;

export const FooterText = styled(Text)``;

export const ListItemContainer = styled.View`
  flex: 1;
  margin-right: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const ListItemIcon = styled(Icon)`
  color: ${props => props.theme.colors.grayscale.slot3};
`;
